import { Nav } from 'react-bootstrap';
import { FaBars, FaTimes } from 'react-icons/fa';
import '../Sidebar.css';
import { NavLink } from 'react-router-dom';
import { useState } from "react";

const Sidebar = ({ isOpen, toggleSidebar }) => {

    const [openSection, setOpenSection] = useState({
    entry: true,
    report: true,
  });

  const toggleSection = (section) => {
    setOpenSection((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  return (
    <div className={`sidebar bg-info text-dark ${isOpen ? 'open' : 'collapsed'}`}>

      <div className="d-flex justify-content-end p-2" style={{marginTop:50}}>
        <button onClick={toggleSidebar} className="btn btn-sm btn-light">
          {isOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      <Nav className="flex-column pt-3">

      {/* ===== ENTRY SECTION ===== */}
      <div onClick={() => toggleSection("entry")} style={{ cursor: "pointer", fontWeight: "bold" }}>
        📦 {isOpen && "Item Info"}
      </div>

      {openSection.entry && (
        <>
          <NavLink
            to="/itementry" 
            end
            className={({ isActive }) =>
              "nav-link " + (isActive ? "active-menu" : "text-dark")
            }
          >
            🏠 {isOpen && "Item Entry"}
          </NavLink>

          <NavLink
            to="/itemInfo"
            className={({ isActive }) =>
              "nav-link " + (isActive ? "active-menu" : "text-dark")
            }
          >
            📄 {isOpen && "Item View"}
          </NavLink>

        </>
      )}

      <hr />

      {/* ===== ORDER SECTION ===== */}
      <div onClick={() => toggleSection("order")} style={{ cursor: "pointer", fontWeight: "bold" }}>
        📊 {isOpen && "Orders"}
      </div>

      {openSection.order && (
        <>
          <NavLink
            to="/pendingOrder"
            className={({ isActive }) =>
              "nav-link " + (isActive ? "active-menu" : "text-dark")
            }
          >
            📄 {isOpen && "Pending Order"}
          </NavLink>

          <NavLink
            to="/finishOrder"
            className={({ isActive }) =>
              "nav-link " + (isActive ? "active-menu" : "text-dark")
            }
          >
            📧 {isOpen && "Finish Order"}
          </NavLink>
        </>
      )}

      <hr/>
      {/* ===== MESSAGE SECTION ===== */}
      <div onClick={() => toggleSection("message")} style={{ cursor: "pointer", fontWeight: "bold" }}>
        📊 {isOpen && "Message"}
      </div>

      {openSection.message && (
        <>
          <NavLink
            to="/unReadMessage"
            className={({ isActive }) =>
              "nav-link " + (isActive ? "active-menu" : "text-dark")
            }
          >
            📄 {isOpen && "Un-Read"}
          </NavLink>

          <NavLink
            to="/readMessage"
            className={({ isActive }) =>
              "nav-link " + (isActive ? "active-menu" : "text-dark")
            }
          >
            📧 {isOpen && "Read"}
          </NavLink>
        </>
      )}
    </Nav>
    </div>
  );
};

export default Sidebar;